<template>
    <ASidebar area="channel-upsell" :enabled="enabled" @beforeopen="install">
        <slot />
    </ASidebar>
</template>

<script>
/**
 * Open the given channel upsell in the sidebar
 */
export default {
    name: 'AChannelSidebar',
    props: {
        upsellData: {type: Object, default: null},
    },

    computed: {
        enabled() {
            return !!this.upsellData;
        }
    },

    methods: {
        install() {
            this.$root.$refs.channelupsell.install(this.upsellData);
            this.$emit('beforeopen');
        }
    },
}
</script>
